import React from 'react';
import { isEmpty } from 'lodash';
import { Gql } from '@fiverr-private/dynamic_matching';
import { useBriefContext } from '@fiverr-private/ai_brief/dist/esm/src/common/BriefContext';
import { useBriefCreationContext } from '../../../context/BriefCreationContext';
import { SectionTag } from '../SectionTag';
import { AppI18n } from '../../../i18n';
import { BriefNeedType } from './types';
import { COPIES_PREFIX } from './consts';
import { NEED_TYPE_SECTION_ID } from '.';

export const NeedTypeTag: React.FC = () => {
  const { brief, enableEnhancedUx } = useBriefCreationContext();
  const { updateEditedBrief, setEditedSectionId } = useBriefContext();
  const needTypeSection = brief?.sections.find((section) => section.id === NEED_TYPE_SECTION_ID);
  const needTypeContent = needTypeSection?.content as unknown as BriefNeedType;

  if (isEmpty(needTypeContent) || !needTypeContent.needType) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    if (enableEnhancedUx) {
      e.stopPropagation();
      updateEditedBrief(null, NEED_TYPE_SECTION_ID, { focused: true });
      setEditedSectionId(NEED_TYPE_SECTION_ID);
    }
  };

  const { needType } = needTypeContent;

  const needTypeCopy = `${COPIES_PREFIX}.${
    needType === Gql.DmBriefNeedType.OneTime ? 'one_time' : 'ongoing'
  }.title` as const;

  return (
    <SectionTag onClick={enableEnhancedUx ? handleClick : undefined}>
      <AppI18n k={needTypeCopy} />
    </SectionTag>
  );
};
